import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IPaymentCard } from "../../Orchestrator/Types/Index";

export async function getPaymentCards(userId: string): Promise<IApiResponse<IPaymentCard[]>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getPaymentCards(userId);
    return await apiRequest<IPaymentCard[]>(endpoint, "GET");
}